import { useQuery } from '@apollo/client';
import { CURRENT_CLIENT_CONFIG } from 'pe-core-frontend';
import { useMemo } from 'react';
export const useCurrentClientConfig = () => {
    const { data, loading } = useQuery(CURRENT_CLIENT_CONFIG);
    const clientConfig = useMemo(() => data?.currentClientConfig || null, [data]);
    return { clientConfig, loading };
};
